import React from 'react'

import LatePaymentsList from '../Billing/LatePaymentsList'

export default class LatePaymentsWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="card">
                <div class="header">
                    <h4 class="title">Late Payments</h4>
                    <p class="category">See a list of tenants who are behind on payments</p>
                </div>
                <div class="content">
                    <div class="row">
                        <div class="col-md-12">
                            <LatePaymentsList />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Billing/LatePaymentsWidget.jsx